import React, { useMemo } from 'react'
import { dialogTypes } from '@/dialogs'
import { realEstateStatus } from '@/enums/RealEstateStatus'
import {
  LookupNameColumn,
  Column,
  EnumCell, DateCell, DateFilterCell, EnumFilterCell
} from '@/components/BsrsGrid'
import { PropertyRenderer } from '@/components/changeRequests'
import { useLocalization } from '@/hooks/localization'
import { percentageCellExport, PercentageFilterCell } from '@/components/BsrsGrid/percentageFilterCell'
import { institutionPermissionTypes } from '@/enums/institutionPermissionTypes'
import { PermissionSectionProvider } from '@/components/changeRequests/institutionPermissionProvider'

const BranchRealEstates = React.memo(function BranchRealEstates ({ dataSource }) {
  return <RealEstates dataSource={dataSource} institutionPermission={institutionPermissionTypes.enum.Branches} />
})

const InstitutionRealEstates = React.memo(function InstitutionRealEstates ({ dataSource }) {
  return <RealEstates dataSource={dataSource} institutionPermission={institutionPermissionTypes.enum.RealEstates} />
})

const RealEstates = React.memo(function RealEstates ({ dataSource, detailDataSource, institutionPermission }) {
  const { localize, locale } = useLocalization()
  const detailDialog = useMemo(() => ({ dialogType: dialogTypes.realEstate, loadData: detailDataSource }), [detailDataSource])
  return (
    <PermissionSectionProvider institutionPermission={institutionPermission}>
      <PropertyRenderer name='realEstates' inputType='grid' dataSource={dataSource}
        addButtonLabel='Institutions.AddRealEstate' detailDialog={detailDialog}>
        {LookupNameColumn({ locale, field: 'propertyType', title: localize('Institutions.PropertyType'), editable: false, width: '200px' })}
        {LookupNameColumn({ locale, field: 'ownershipType', title: localize('Institutions.OwnershipType'), editable: false, width: '200px' })}
        <Column field='purchaseDate' title={localize('Institutions.PurchaseDate')} filter='date' filterCell={DateFilterCell} cell={DateCell} width='150px' />
        <Column field='investmentRatio' title={localize('Institutions.InvestmentRatio')} filter='numeric' format='{0:p0}' width='150px' filterCell={PercentageFilterCell} cellExport={percentageCellExport} />
        <Column field='marketCost' title={localize('Institutions.MarketCost')} filter='numeric' width='200px' />
        <Column field='nominalCost' title={localize('Institutions.NominalCost')} filter='numeric' width='200px' />
        <Column field='status' title={localize('Common.Status')} cell={EnumCell({ localize, enumName: realEstateStatus.enumName })} filterCell={EnumFilterCell({ localize, enumName: realEstateStatus.enumName }, realEstateStatus.values)} enumName={realEstateStatus.enumName} width='200px' />
      </PropertyRenderer>
    </PermissionSectionProvider>
  )
})

export { InstitutionRealEstates, BranchRealEstates }



// WEBPACK FOOTER //
// ./src/components/demographics/realEstates.js